<template>
    <div v-loading="loading" class="box-score-done">
        <div v-if="!loading">
            <div class="mg-t-2">
                <i class="fas fa-trophy color-warning text-font-36"></i>
            </div>
            <p class="mg-t-2 text-font-24">คุณทำคะแนนได้ <span class="color-primary text-font-30">{{score}}</span> จาก {{total}} คะแนน</p>
            <el-button 
                @click="$router.push(`/course/learn?courseId=${$route.query.courseId}&subjectId=${$route.query.subjectId}${topicLatest}`)"
                type="primary"
                round
                class="pd-x-1 mg-y-1">ดำเนินการต่อ</el-button>
        </div>
    </div>
</template>

<script>
import { HTTP } from "@/service/axios.js";
export default {
    props:{
        type:{
            type:String,
            default(){
                return 'preTest'
            }
        },
        subjectId:{
            type:String,
            default(){
                return ''
            }
        },
        courseId:{
            type:String,
            default(){
                return ''
            }
        }
    },
    computed: {
        token() {
            return this.$store.state.token;
        },
        user() {
            return this.$store.state.user;
        },
        topicLatest() {
            return this.$store.state.topicLatest;
        },
    },
    data() {
        return {
            loading:true,
            score:0,
            total:0
        }
    },
    mounted() {
        this.fetchPercentSubjects()
    },
    watch: {
        courseId(){
            this.fetchPercentSubjects()
        }
    },
    methods: {
        fetchPercentSubjects() {
            if (this.courseId) {
                let obj = {
                    courseId: this.courseId,
                    userId: this.user.userId,
                };

                HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
                HTTP.post(`percent/subjects`, obj)
                .then((res) => {
                  
                    let filter = res.data.obj.subjects.filter(filter => filter._id == this.subjectId)
                    if (filter.length > 0) {
                        this.score = this.type == 'preTest'?filter[0].preTestScore:filter[0].postTestScore
                        this.total = this.type == 'preTest'?filter[0].preTestTotal:filter[0].postTestTotal
                    }
                })
                .catch((e) => {
                    // this.alertCatchError(e);
                    console.log("fetchManagePoint error", e);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 500);
                });
            }
        },
    },
}
</script>

<style scoped>
    .box-score-done{
        min-height: 250px;
    }
</style>